/* ── Invite Dialog ──────────────────────────────────────────────────────── */
function InviteDialog({showToast,onClose,onInvite}){
  const [email,setEmail]=React.useState('');
  const [role,setRole]=React.useState('viewer');
  const [sending,setSending]=React.useState(false);
  const submit=e=>{
    e.preventDefault();
    if(!email||!email.includes('@')){showToast&&showToast('Enter a valid email');return;}
    setSending(true);
    setTimeout(()=>{setSending(false);onInvite(email)},600);
  };
  return(
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}} onClick={onClose}>
      <div style={{background:'var(--surface)',borderRadius:12,width:420,maxWidth:'92vw',boxShadow:'0 20px 50px rgba(0,0,0,.3)'}} onClick={e=>e.stopPropagation()}>
        <div style={{padding:'18px 20px',borderBottom:'1px solid var(--border)',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <h3 style={{fontSize:15,fontWeight:600}}>Invite Team Member</h3>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close"><CloseIcon size={16}/></button>
        </div>
        <form onSubmit={submit} style={{padding:20}}>
          <div style={{marginBottom:14}}>
            <label style={{fontSize:11,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'.5px',marginBottom:4,display:'block'}}>Email</label>
            <input className="input" type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="colleague@company.com" autoFocus required/>
          </div>
          <div style={{marginBottom:18}}>
            <label style={{fontSize:11,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'.5px',marginBottom:4,display:'block'}}>Role</label>
            <select className="input" value={role} onChange={e=>setRole(e.target.value)}>
              <option value="admin">Admin</option>
              <option value="operator">Operator</option>
              <option value="developer">Developer</option>
              <option value="viewer">Viewer</option>
            </select>
          </div>
          <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
            <button type="button" className="btn btn-ghost" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={sending}>{sending?'Sending…':'Send Invite'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
